import Image from "next/image";

import type { PictureProps } from "@types";

const Picture = ({
  className,
  size,
  src,
  alt, // Now mandatory
  loading = "lazy",
  decoding = "async",
  ...rest
}: PictureProps) => {
  const width = size[0];
  const height = size.length === 1 ? size[0] : size[1];
  const defaultAtl = alt? alt:"ratl";

  return (
    <Image
      className={className}
      width={`${width}`}
      height={`${height}`}
      alt={defaultAtl} // Use the provided alt directly
      src={src}
      loading={loading}
      decoding={decoding}
      {...rest}
    />
  );
};

export default Picture;
